import { environment } from '../../../../environments/environment';
// import * as angular from 'angular';

(function () {
  'use strict';

  angular.module('app').service('PaymentGatewayService', PaymentGatewayService);

  PaymentGatewayService.$inject = [
    'RestResource',
    'CONFIGURATIONS',
    '$translate',
    '$filter',
    'UtilService',
    'SessionService',
    'WindowModalService',
  ];

  function PaymentGatewayService(
    RestResource,
    config,
    $translate,
    $filter,
    UtilService,
    SessionService,
    WindowModalService
  ) {
    var utils = new UtilService(this);

    $translate = $filter('translate');

    var apiUrl = environment.apiEndpoint + 'companies';

    var service = {
      getPaymentGateways: getPaymentGateways,
      savePaymentGateway: savePaymentGateway,
      openPaymentGatewayModal: openPaymentGatewayModal,
      setDefaultPaymentGateway: setDefaultPaymentGateway,
    };

    return service;

    ////////////////

    function getPaymentGateways() {
      var url = apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/payment_gateways';

      return RestResource.request(
        'get',
        url,
        {},
        function (response) {
          return response.data;
        },
        {}
      );
    }

    function savePaymentGateway(paymentGateway, language) {
      var url = apiUrl + '/' + SessionService.getSelectedAccountCompany().id + '/payment_gateways';
      var method = 'post';

      if (paymentGateway.id) {
        // edit
        url += '/' + paymentGateway.id;
        method = 'put';
      }

      var lang = language ? language : config.DEFAULT_CONTENT_LANGUAGE;

      return RestResource.request(
        method,
        url,
        { payment_gateway: paymentGateway },
        function (response) {
          var msg = !paymentGateway.id ? 'PAYMENT_GATEWAY_ADDED' : 'PAYMENT_GATEWAY_MODIFIED';
          utils._successMsg($translate(msg));

          return response.data;
        },
        function (response) {
          return response.data;
        }
      );
    }

    function openPaymentGatewayModal(paymentGateway, mode, paymentMethods, successCallback) {
      var templateUrl = './app/ajs/payment-gateways/modals/payment-gateway-detail-modal.html';

      var originalItem = angular.copy(paymentGateway);

      var modalParams = {
        title: 'PAYMENT_GATEWAY_DETAILS',
        item: originalItem,
        additionalParams: {
          paymentMethods: paymentMethods,
        },
        mode: mode,
        preventModalClose: true,
      };

      // if (!paymentGateway.id){
      //     modalParams.closeOnSave = false; // Do not close modal after create
      // }

      // onSavedItem in modal service
      let confirmCallback = function (response) {
        if (paymentGateway.id) {
          // Edit
          // paymentGateway.name = response.name;
          paymentGateway.enabled = response.enabled;
          paymentGateway.system_enabled = response.system_enabled;
          paymentGateway.website_enabled = response.website_enabled;
          paymentGateway.is_default = response.is_default;
          paymentGateway.payment_method_id = response.payment_method_id;

          paymentGateway.paymentMethodName = paymentMethods.find(
            (paymentMethod) => paymentMethod.id === paymentGateway.payment_method_id
          ).name;

          switch (paymentGateway.idt) {
            // Paypal
            case 'paypal':
              paymentGateway.paypal_client_id = response.paypal_client_id;
              paymentGateway.paypal_client_secret = response.paypal_client_secret;
              break;

            // Bac ecommerce usd
            case 'bac_ecommerce_usd':
              paymentGateway.bac_processor_id_usd = response.bac_processor_id_usd;
              paymentGateway.bac_key_id_usd = response.bac_key_id_usd;
              paymentGateway.bac_key_usd = response.bac_key_usd;
              break;

            // Bac ecommerce crc
            case 'bac_ecommerce_crc':
              paymentGateway.bac_processor_id_crc = response.bac_processor_id_crc;
              paymentGateway.bac_key_id_crc = response.bac_key_id_crc;
              paymentGateway.bac_key_crc = response.bac_key_crc;
              break;

            // Bcr ecommerce usd
            case 'bcr_ecommerce_usd':
              paymentGateway.bcr_login_id_usd = response.bcr_login_id_usd;
              paymentGateway.bcr_transaction_key_usd = response.bcr_transaction_key_usd;
              break;

            // Bcr ecommerce crc
            case 'bcr_ecommerce_crc':
              paymentGateway.bcr_login_id_crc = response.bcr_login_id_crc;
              paymentGateway.bcr_transaction_key_crc = response.bcr_transaction_key_crc;
              break;
          }

          return utils.itemListChanged(response.id);
        }

        // return successCallback(response);
      };

      WindowModalService.open(templateUrl, modalParams, confirmCallback);
    }

    function setDefaultPaymentGateway(defaultPayment, successCallback) {
      var url =
        apiUrl +
        '/' +
        SessionService.getSelectedAccountCompany().id +
        '/payment_gateways/' +
        defaultPayment.id;

      defaultPayment.is_default = true;

      var params = {
        payment_gateway: defaultPayment,
        set_default: true,
      };

      return RestResource.request(
        'put',
        url,
        params,
        function () {
          var msg = $translate('DEFAULT_PAYMENT_GATEWAY_CHANGED');
          utils._successMsg(msg);

          return successCallback();
        },
        function (response) {
          utils._errorMsg(response.data.error);
          return false;
        }
      );
    }
  }
})();
